export default {
  textAlign: 'center' as const,
  marginTop: 50,
}
